import { MetasTransactionEnum } from '@app/core/enums/metas.enum';

export interface IMarketingMeta {
    metaName: string;
    metaKey: string;
    metaId: string;
}

export const marketingMetas: Array<IMarketingMeta> = [
    {
        metaName: MetasTransactionEnum.UTM_SOURCE,
        metaKey: MetasTransactionEnum.UTM_SOURCE,
        metaId: 'new_0'
    },
    {
        metaName: MetasTransactionEnum.UTM_CAMPAIGN,
        metaKey: MetasTransactionEnum.UTM_CAMPAIGN,
        metaId: 'new_2'
    },
    {
        metaName: MetasTransactionEnum.UTM_MEDIUM,
        metaKey: MetasTransactionEnum.UTM_MEDIUM,
        metaId: 'new_3'
    },
    {
        metaName: MetasTransactionEnum.UTM_CONTENT,
        metaKey: MetasTransactionEnum.UTM_CONTENT,
        metaId: 'new_4'
    },
    {
        metaName: MetasTransactionEnum.UTM_TERM,
        metaKey: MetasTransactionEnum.UTM_TERM,
        metaId: 'new_5'
    },
    {
        metaName: 'gclid',
        metaKey: MetasTransactionEnum.GOOGLE_GCLID,
        metaId: 'new_1'
    },
    {
        metaName: 'fbclid',
        metaKey: MetasTransactionEnum.FACEBOOK_FBCLID,
        metaId: 'new_6'
    },
    {
        metaName: MetasTransactionEnum.REFERRER,
        metaKey: MetasTransactionEnum.REFERRER,
        metaId: 'new_7'
    }
];
